import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { currentUserApi } from "api/services/authentication";



export const fetchUser = createAsyncThunk("fetchUser", async () => {
  const res = await currentUserApi();
  // console.log(res, "ressss")
  return res?.data
});


export const userSlice = createSlice({
  name: "user",
  initialState: { 
    value: { email: "", password: "" , header:false },
    user: {},
    userLoading: false
   },
  extraReducers: (builder) => {
    builder.addCase(fetchUser.pending, (state, action) => {
     state.userLoading = true;
    })
    builder.addCase(fetchUser.fulfilled, (state, {payload}) => {
      state.userLoading = false;
      state.user = payload;
     })
    

  },
  reducers: {
    login: (state, { payload }) => {
      state.value = payload;
    },
    logout: (state) => {
      state.value = { email: "", password: "" };
    },
    setLayout: (state, { payload }) => {
      state.layout = payload;
    },
    setToogleHeader: (state, { payload }) => {
      state.header = payload;
    },
  },
});

export const { login, logout, setLayout , setToogleHeader} = userSlice.actions;
export default userSlice.reducer;
